import { Directive, AfterViewInit, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[appScrollTo]' })
export class ScrollToDirective implements AfterViewInit {

    @Input()
    public appScrollTo = true;

    constructor(private _elRef: ElementRef) { }

    ngAfterViewInit(): void {
        if (this.appScrollTo) {
            this._elRef.nativeElement.scrollIntoView({
                behavior: 'smooth', block: 'center'
            });
        }
    }
}
